import { NgModule } from '@angular/core';

import { MijnLoginTemplateModule } from '@ap/mijn-template';
import { ApButtonComponent } from '@ap/button';
import { ApContentPipe, ApContentComponent } from '@ap/content';
import { ApAuthenticatieFidoModule } from '@ap/interface-apic-authenticatie-fido';
import { SessiebeheerModule } from '@ap/interface-apic-sessiebeheer';
import { TokenbeheerModule } from '@ap/interface-apic-tokenbeheer';

import { BrowsercodeHerstelWrapperComponent } from './browsercode-herstel.wrapper.component';

/**
 * @ngdoc module
 * @name BrowsercodeHerstelWrapperModule
 */
@NgModule({
    declarations: [BrowsercodeHerstelWrapperComponent],
    imports: [
        ApAuthenticatieFidoModule,
        ApButtonComponent,
        ApContentPipe,
        ApContentComponent,
        MijnLoginTemplateModule,
        SessiebeheerModule,
        TokenbeheerModule
    ],
    exports: [BrowsercodeHerstelWrapperComponent]
})
export class BrowsercodeHerstelWrapperModule {}
